export default __webpack_public_path__ + "icon_dashboard.04b1134d1ad7d80081a9920731135280.svg";